import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import CybersourceCredentialsStore from "../../../stores/credentials/cybersource-credentials-store";

interface IIntegrationProps {
    credentialsStore: CybersourceCredentialsStore,
    vGroup: IValidationGroup,
}

const CybersourceCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='Merchant ID'
                note='Your Cybersource merchant ID'
                required
                key='merchant_id'
            >
                <Input
                    value={credentialsStore.merchant_id}
                    placeholder=''
                    onChange={v => credentialsStore.merchant_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='API Key'
                note='Your Cybersource API key'
                required
                key='api_key'
            >
                <Input
                    value={credentialsStore.api_key}
                    placeholder=''
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='API Secret'
                note='Your Cybersource API Secret'
                key='api_secret'
                required
            >
                <Input
                    value={credentialsStore.api_secret}
                    placeholder=''
                    onChange={v => credentialsStore.api_secret = v}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    )
});

export default CybersourceCredentials;